module.exports = __webpack_public_path__ + "img/madrid360.1a27d244.jpg";